<script setup>
import { ref } from 'vue';
import { useWidgetStore } from '@/stores/widget';
import { storeToRefs } from 'pinia';
import WidgetConfigurationPage from './WidgetsConfigurationPage.vue';

const widgetStore = useWidgetStore();
const { allWidgets } = storeToRefs(widgetStore);

const selectedWidgetId = ref(null);
const showConfig = ref(false);

const handleSelectWidget = (id) => {
    const widget = allWidgets.value.find(w => w.id === id);
    if (widget && widget.hash) {
        window.location.href = `/widgets/${widget.hash}`;
    }
};

const handleCreateNew = () => {
    selectedWidgetId.value = null;
    showConfig.value = true;
};
</script>

<template>
<MainContentLayout>
    <template #breadcrumb><BreadCrumb /></template>
    <template v-if="!showConfig" #title>{{ $t('widget.widget_management') }}</template>

    <div v-if="!showConfig">
        <button class="btn mb-4 text-white px-4 py-2 rounded" @click="handleCreateNew">{{ $t('widget.create_new_widget') }}</button>
        <div v-if="allWidgets && allWidgets.length">
            <ul class="mb-6">
                <li v-for="widget in allWidgets" :key="widget.id" class="flex flex-col mb-4 p-3 border-grey-300 border-2 shadow-sm rounded bg-white">
                    <div class="flex items-center justify-between mb-1">
                        <span class="font-bold text-lg">{{ widget.name }}</span>
                        <button class="btn text-white px-3 py-1 rounded" @click="handleSelectWidget(widget.id)">{{ $t('label.edit') }}</button>
                    </div>
                    <div v-if="widget.widget_sources && widget.widget_sources.length">
                        <div v-for="source in widget.widget_sources" :key="source.id" class="ml-2">
                            <div><span class="font-semibold">{{ $t('widget.url') }}:</span> <a :href="source.url" target="_blank" class="text-blue-600 underline">{{ source.url }}</a></div>
                            <div><span class="font-semibold">{{ $t('widget.source_description') }}:</span> {{ source.description }}</div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div v-else>
        <WidgetConfigurationPage @back="showConfig = false" />
    </div>
</MainContentLayout>
</template>
